__turbopack_context__.v({
  "backgroundImage": "styles-module__DQW-Gq__backgroundImage",
  "btn": "styles-module__DQW-Gq__btn",
  "buttonContainer": "styles-module__DQW-Gq__buttonContainer",
  "description": "styles-module__DQW-Gq__description",
  "initialized": "styles-module__DQW-Gq__initialized",
  "is-selected": "styles-module__DQW-Gq__is-selected",
  "leftPart": "styles-module__DQW-Gq__leftPart",
  "navigation": "styles-module__DQW-Gq__navigation",
  "rightPart": "styles-module__DQW-Gq__rightPart",
  "slide": "styles-module__DQW-Gq__slide",
  "slider": "styles-module__DQW-Gq__slider",
  "sliderContainer": "styles-module__DQW-Gq__sliderContainer",
  "title": "styles-module__DQW-Gq__title",
  "titleContainer": "styles-module__DQW-Gq__titleContainer",
});
